// extracted by mini-css-extract-plugin
module.exports = {"statement":"index_statement__W3S87","original":"index_original___WH4m"};